import { Button } from 'antd'
import clsx from 'clsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from '../company-config.module.scss'

type CompanyConfigYesNoComponentProps = {
  majorText: string
  minorText: string
  initialState?: boolean
  onStateChange: (state: boolean) => void
  error: string | undefined
}

export const CompanyConfigYesNoComponent = ({ majorText, minorText, initialState, onStateChange, error }: CompanyConfigYesNoComponentProps) => {
  const { t } = useTranslation()
  const [state, setState] = useState<boolean | undefined>(initialState)

  const handleStateChange = (state: boolean) => {
    setState(state)
    onStateChange(state)
  }

  return (
    <div className="col-12 col-lg-6">
      <div className="bg-white rounded-4 pb-5 pt-4 px-3 px-md-5 mb-3 d-flex justify-content-between flex-wrap flex-md-nowrap">
        <div className={clsx(styles.config, 'd-flex flex-column justify-content-center col-12 col-sm-6 mb-1 mb-sm-0')}>
          <span className={styles.configTextMajor}>{majorText}</span>
          <span className={styles.configTextMinor}>{minorText}</span>
          {error ? <div className={clsx(styles.configErrorMessage, 'error-message mt-1')}>{error}</div> : null}
        </div>
        <div className="d-flex justify-content-around">
          <Button
            className={clsx({
              ['ant-btn-color-primary']: state === true,
            })}
            onClick={() => {
              handleStateChange(true)
            }}
            size="large"
          >
            {t('common.yes')}
          </Button>
          <Button
            className={clsx('ms-3', {
              ['ant-btn-color-primary']: state === false,
            })}
            onClick={() => {
              handleStateChange(false)
            }}
            size="large"
          >
            {t('common.no')}
          </Button>
        </div>
      </div>
    </div>
  )
}
